import React from 'react';
import { CategoryTitleColumnsStyled, CategoryTitleStyled } from './styled';
import { H4 } from 'ds/components/typography';
import { useLocale, HebrewKeys } from 'locale';

import ExcavatorIcon from 'assets/svg/excavator.svg';
import PencilRulerIcon from 'assets/svg/pencil-ruler.svg';
import { ConstructionTypes } from 'store/state/selectors/insights/summaryTypes';

interface CategoryTitleProps {
  amount: number;
  type: ConstructionTypes;
}

const constructionTypeToLocaleString: Record<ConstructionTypes, HebrewKeys> = {
  [ConstructionTypes.IN_CONSTRUCTION]: 'unitPage.constructionsInProgress',
  [ConstructionTypes.IN_FILING]: 'unitPage.constructionsInFiling',
  [ConstructionTypes.IN_FILING_APPROVED]: 'unitPage.constructionsInFilingApproved',
};

const CategoryTitles: React.FC<CategoryTitleProps> = ({ type, amount }): JSX.Element => {
  const { t } = useLocale();
  if (amount > 0) {
    return (
      <H4 weight="medium">{t(constructionTypeToLocaleString[type], { amount })}</H4>
    );
  }
  else {
    return (
      <CategoryTitleColumnsStyled>
        <H4 weight="medium">{t(constructionTypeToLocaleString[type], { amount })}</H4>
      </CategoryTitleColumnsStyled>
    );
  }
};


export const CategoryTitle: React.FC<CategoryTitleProps> = ({ amount, type }) => {
  return (
    <CategoryTitleStyled>
      {type === ConstructionTypes.IN_CONSTRUCTION ?  <ExcavatorIcon/> : <PencilRulerIcon/>}
      <CategoryTitles
        type={type}
        amount={amount}
      />
    </CategoryTitleStyled>
  );
};
